<div class="contact-input-panel" [formGroup]="formGroup()">
  <div class="row">
    <mat-form-field appearance="outline">
      @if (formGroup().get('caseNumber')?.invalid && formGroup().get('caseNumber')?.touched) {
        <mat-error>
          {{ 'order-contact.order-contact-data-input.case-field-required' | translate }}
        </mat-error>
      }
        <mat-label>{{ 'order-contact.order-contact-data-input.choose-case-number' | translate }}</mat-label>
      <mat-select formControlName="caseNumber" aria-required="true" required>
        @for (case of cases(); track case.caseIdHash ) {
          <mat-option value="{{ case.caseIdHash }}">{{ 'currency' | translate: { amount: case.balance | number: '1.2-2' : 'fr-FR'} }} {{case.presentCreditorShortName }}</mat-option>
        }@empty {
          <mat-option>
            <debtor-panel-loading-spinner-select [isLoading]="store.isCasesLoading()"/>
            @if(!store.isCasesLoading() && cases()?.length === 0){
             {{ 'no-data' | translate }}
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline">
      @if (formGroup().get('phoneNumber')?.invalid && formGroup().get('phoneNumber')?.touched) {
        <mat-error>
          {{ 'order-contact.order-contact-data-input.phone-field-required' | translate }}
        </mat-error>
      }
      <mat-label>{{ 'order-contact.order-contact-data-input.choose-phone-number' | translate }}</mat-label>
      <mat-select formControlName="phoneNumber" aria-required="true" required>
        @for (phone of phoneNumbers(); track phone.phoneIdHash ) {
          <mat-option [value]="phone">{{ phone.phone }}</mat-option>
        }@empty {
          <mat-option>
            <debtor-panel-loading-spinner-select [isLoading]="store.isPhonesLoading()"/>
            @if(!store.isPhonesLoading() && phoneNumbers()?.length === 0) {
              {{ 'no-phone-data' | translate }}
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'order-contact.order-contact-data-input.choose-date' | translate }}</mat-label>
      <input matInput [matDatepickerFilter]="myDateFilter" [matDatepicker]="picker"
      [min]="minDate" [max]="this.store.getMaxCallbackDays()"
      aria-required="true" required
      formControlName="date" (dateChange)="changeDate()">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'order-contact.order-contact-data-input.choose-hour' | translate }}</mat-label>
      <input matInput [matTimepicker]="minutesPicker" [matTimepickerMin]="minHour()" [matTimepickerMax]="this.store.getMaxOpenHours()" formControlName="hour"
        aria-required="true" required>
      <mat-timepicker-toggle matIconSuffix [for]="minutesPicker"/>
      <mat-timepicker interval="2h" #minutesPicker/>
    </mat-form-field>
  </div>
  <!-- <div class="row checkbox-container">
    <mat-checkbox
      class="example-margin"
      formControlName="checked"
      (change)="checkboxToggle($event)"
    >
      {{ 'order-contact.order-contact-data-input.contact-information' | translate }}
    </mat-checkbox>
  </div> -->
</div>
